/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'gslb';
const componentName = 'gslb-pool-member-domain-name';
const prefix = `${moduleName}.${componentName}`;

export const ipOrFqdnInputLabel = `${prefix}.ipOrFqdnInputLabel`;
export const ipOrFqdnInputPlaceholder = `${prefix}.ipOrFqdnInputPlaceholder`;
export const fqdnInputLabel = `${prefix}.fqdnInputLabel`;
export const fqdnInputPlaceholder = `${prefix}.fqdnInputPlaceholder`;
export const resolvedFqdnDropdownLabel = `${prefix}.resolvedFqdnDropdownLabel`;
export const resolvedFqdnDropdownPlaceholder = `${prefix}.resolvedFqdnDropdownPlaceholder`;
export const resolveFqdnToV6Label = `${prefix}.resolveFqdnToV6Label`;

export const ENGLISH = {
    [ipOrFqdnInputLabel]: 'IP(v4/v6) Address or FQDN or Target',
    [ipOrFqdnInputPlaceholder]: 'Enter IP(v4/v6) Address or FDQN or Target',
    [fqdnInputLabel]: 'FQDN or Target',
    [fqdnInputPlaceholder]: 'Enter FDQN or Target',
    [resolvedFqdnDropdownLabel]: 'Resolved IP(v4/v6) Address',
    [resolvedFqdnDropdownPlaceholder]: 'Select Resolved IP(v4/v6) Address',
    [resolveFqdnToV6Label]: 'Resolve FQDN to IPv6',
};
